import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';
import { CUSTOMER_PHONE_NUMBER } from 'config/constants';
import '../ErrorMessage/ErrorMessage.scss';

export default class DropshipContactMessage extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		country: PropTypes.string.isRequired,
	};

	messageId = 'cart.newAddress.CustomerCare';

	render() {
		const { show } = this.props;
		const showMsg = show ? 'show' : '';
		const customerPhone = CUSTOMER_PHONE_NUMBER[this.props.country];

		return (
			<div className={`ErrorMessage ${showMsg}`}>
				<FormattedMessage id={this.messageId} values={{ customerPhone }} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DropshipContactMessage/index.js